import type { IGStepDot } from '~/presentation/ui';

export const TEMPLATE_TESTING_GUIDE_STEPS_AMOUNT = 3;

export const TEMPLATE_TESTING_GUIDE_DEFAULT_TRAFFIC_SPLIT_RATIO = 0.5;
export const TEMPLATE_TESTING_GUIDE_IMAGE_RATIO = 451 / 168;

export const TEMPLATE_TESTING_GUIDE_STEPS: IGStepDot[] = [
  {
    step: 1,
    title: 'Page',
  },
  {
    step: 2,
    title: 'Variant',
  },
  {
    step: 3,
    title: 'Traffic',
  },
];
